import React, { useEffect, useState } from 'react';
import { Input, Checkbox, Form, Spin, Table } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import columns from '../../../../../columns/liveAccount.js';
import ModalComponent from '../../../../../components/modals/ModalComponent.jsx';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import DepositWallet from '../../../../../assets/DepositWallet.jsx';
import DepositAccount from '../../../../../assets/DepositAccount.jsx';
import { GetMT5AccountsApi } from '../../../../../api/request/transfer.js';
import { DepositAmountApi, GetWalletApi, GetPaymentGatewayByIdApi } from '../../../../../api/request/wallet/deposit.js';

export default function DepositUSDT() {

    const [form] = Form.useForm();
    const params = useParams();
    const { userDetails } = useSelector(state => state.user);
    const [initialValues, setInitialValues] = useState({ amount: '', currency: null, conditions: false });
    const [wallet, setWallet] = useState({});
    const [paymentGateway, setPaymentGateway] = useState({});
    const [isWalletLoading, setIsWalletLoading] = useState(false);
    const [isWayLoading, setIsWayLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [isDepositChoiceModalOpen, setIsDepositChoiceModalOpen] = useState(false);
    const [isTradingModalOpen, setIsTradingModalOpen] = useState(false);
    const [isDepositLoading, setIsDepositLoading] = useState(false);

    const getWallet = async () => {
        try {
            setIsWalletLoading(true);
            let params = {
                RuleType: 'Deposit'
            }
            const { data } = await GetWalletApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                setWallet(data?.data)
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    const getPaymentGateway = async () => {
        try {
            setIsWayLoading(true);
            let apiParams = {
                PaymentGatewayId: params?.id
            }
            const { data } = await GetPaymentGatewayByIdApi(new URLSearchParams(apiParams).toString());
            if (data?.success) {
                setPaymentGateway(data?.data);
            }
            setIsWayLoading(false);
        } catch (error) {
            setIsWayLoading(false);
        }
    }

    const getAccounts = async () => {
        try {
            const { data } = await GetMT5AccountsApi(true);
            if (data?.success) {
                setData(
                    (data?.data)?.filter(account => account.isLive === true)?.map((item) => {
                        return { key: (item?.login).toString(), ...item }
                    })
                );
            }
        } catch (error) { }
    }

    const handleSubmit = (values) => {
        setFormValues(values);
        setIsDepositChoiceModalOpen(true);
    };

    const handleOpenTradingModal = () => {
        setIsDepositChoiceModalOpen(false);
        setIsTradingModalOpen(true);
    };

    const handleDeposit = async (type) => {
        const isWallet = type === 'wallet';
        if (!selectedRowKeys.length && !isWallet) {
            return toast.error('Please select a trading account.');
        }
        try {
            setIsDepositLoading(true);
            const deposiParams = {
                userId: userDetails?._id,
                paymentGatwayId: params?.id,
                amount: Number(formValues?.amount),
                loginTerminalId: isWallet ? 0 : Number(selectedRowKeys[0]),
            };
            const { data } = await DepositAmountApi(deposiParams);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                if (!isWallet) setSelectedRowKeys([]);
                window.open(data?.data?.redirectUrl, "_self");
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Deposit failed.');
        } finally {
            setIsDepositLoading(false);
            isWallet ? setIsDepositChoiceModalOpen(false) : setIsTradingModalOpen(false);
        }
    };

    const rowSelection = {
        type: 'radio',
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    useEffect(() => {
        if (!isTradingModalOpen) setSelectedRowKeys([])
    }, [isTradingModalOpen]);

    useEffect(() => {
        getWallet();
        getPaymentGateway();
        getAccounts();
    }, []);

    return (
        <div>
            <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                {isWalletLoading ? (
                    <div className="flex justify-center flex-col my-6">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div className='p-4 mb-3 grid sm:grid-cols-3 lg:grid-cols-5 gap-5 lg:divide-x'>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2'>Transaction fees(%)</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.fees}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Processing Time</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.processing_Time}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Currencies</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.currency}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Minimum Deposit</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.minAmount || '0'}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Maximum Deposit</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.maxAmount || '0'}</p>
                        </div>
                    </div>
                )}
            </div>

            <div className='border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5'>
                {isWayLoading ? (
                    <div className="flex justify-center flex-col my-6">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (<div className='flex items-center border-b border-light px-4 lg:px-6 pb-4'>
                    <img src={paymentGateway?.paymentLogoUrl} alt='icon' width={35} height={35} />
                    <p className='text-[#2F2B3D] text-xl font-semibold ml-3 mt-1'>{paymentGateway?.name}</p>
                </div>)}

                <Form className='w-full lg:p-6 p-4' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className='md:flex md:flex-wrap gap-5'>
                        <div className="md:w-1/3 input-white">
                            <label className='text-lg text-[#2F2B3DCC] font-medium'>Amount In USD</label>

                            <Form.Item
                                name='amount'
                                rules={[
                                    { required: true, message: 'Please enter amount.' },
                                    {
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            const amount = Number(value);
                                            if (!Number.isInteger(amount)) {
                                                return Promise.reject(new Error('Please enter a valid amount.'));
                                            }
                                            if (amount < wallet?.minAmount) {
                                                return Promise.reject(new Error(`Amount must be at least $${wallet?.minAmount}.`));
                                            }
                                            if (amount > wallet?.maxAmount) {
                                                return Promise.reject(new Error(`Amount cannot exceed $${wallet?.maxAmount}.`));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input type='number' placeholder="Amount in USD" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>
                        {/* <div className="md:w-1/3 ant-select-selector-white">
                            <label className='text-lg text-[#2F2B3DCC] font-medium'>Crypto Currency</label>
                            <Form.Item name='currency' rules={[{ required: true, message: 'Please select a currency.' }]}>
                                <Select className='w-full mt-1 border-primary' placeholder='Select a currency' options={[{ value: 'USDT_TRC20', label: 'USDT' }]} />
                            </Form.Item>
                        </div> */}
                    </div>
                    <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
                        <Checkbox className='mt-4'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link></Checkbox>
                    </Form.Item>
                    <div className="md:w-1/4 mt-4">
                        <button type="Submit" className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'>Next</button>
                    </div>
                </Form>
            </div>
            {/* --- Modal 1: Choose Wallet or Trading Account --- */}
            <ModalComponent
                isOpen={isDepositChoiceModalOpen}
                setIsOpen={setIsDepositChoiceModalOpen}
                title='Deposit Fund'
                width={600}
            >
                <div className='flex items-center justify-center mt-[-5px]'>
                    <img src="/assets/images/account_switch.png" alt="" className='h-48 w-50' />
                </div>
                <p className='text-xl text-[#2F2B3D] font-semibold text-center mt-3'>Where would you like to deposit the fund?</p>
                <div className='flex items-center gap-5 mt-5 '>
                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg py-2 uppercase themeHover duration-500 w-1/2'
                        disabled={isDepositLoading}
                        lable='Wallet'
                        isLoading={isDepositLoading}
                        loadingLable='Adding request...'
                        onClick={() => handleDeposit('wallet')}
                        img={<DepositWallet />}
                    />
                    <button className={`bg-primary flex items-center justify-center text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover 
                    duration-500 w-1/2 ${isDepositLoading ? "opacity-70 cursor-not-allowed" : null}`}
                        onClick={handleOpenTradingModal}>
                        <DepositAccount />
                        <span className='text-nowrap ms-3'>Trading Account</span>
                    </button>
                </div>
            </ModalComponent>

            {/* --- Modal 2: Choose Trading Account --- */}
            <ModalComponent isOpen={isTradingModalOpen} setIsOpen={setIsTradingModalOpen} title="Please select trading account where you want to deposit" width={650}>
                <div className="flex flex-col gap-4">
                    <Table rowSelection={rowSelection} columns={columns} dataSource={data} pagination={false} />
                    <div className="flex justify-end items-center gap-4 mt-4">
                        <LoadableButton
                            className='bg-[#2D9B63] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#096034] duration-500'
                            disabled={isDepositLoading}
                            lable='Deposit'
                            isLoading={isDepositLoading}
                            loadingLable='Adding request...'
                            onClick={() => handleDeposit('trading')}
                        />
                        <button className='bg-[#D91819] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500'
                            onClick={() => { setIsTradingModalOpen(false); setIsDepositChoiceModalOpen(true); }}>Back</button>
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}
